<template>
  <div class="loader-wrapper">
    <div class="preview-area">
      <div class="sk-double-bounce">
        <div class="sk-child sk-double-bounce1"></div>
        <div class="sk-child sk-double-bounce2"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PreLoader"
};
</script>



// WEBPACK FOOTER //
// src/components/modules/PreLoader.vue